/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { IoCall, IoRestaurant } from "react-icons/io5";
import { FaUserGroup } from "react-icons/fa6";
import { MdEmail, MdOutlineWatchLater } from "react-icons/md";
import { AiFillFlag } from "react-icons/ai";
import ReactQuill from "react-quill";
import { useDispatch } from "react-redux";
import "react-quill/dist/quill.snow.css";
import "react-datepicker/dist/react-datepicker.css";
import { saveActivity } from "../../Redux/CommonSlice";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import ReactSelect from "./ReactSelect";
import { useSelector } from "react-redux";
import { getAllDeals } from "../../Redux/DealSlice";
import { getLeadmaster } from "../../Redux/LeadsSlice";
import { getProject } from "../../Redux/ProjectSlice";

const Activity = ({
  leadData,
  setLoadFist,
  identityID,
  editActivityData,
  identityName,
  handleCancel,
}) => {
  const dispatch = useDispatch();
  const organizationstore = useSelector((state) => state?.root?.organization);
  const Peoplestore = useSelector((state) => state?.root?.Person);
  const Dealstore = useSelector((state) => state.root.Deal);
  const Leadstore = useSelector((state) => state.root.leads);
  const Projectstore = useSelector((state) => state.root.Project);

  const [labelActivityPlaceholder, setLabelActivityPlaceholder] = useState("Call");
  const [activityName, setActivityName] = useState(editActivityData?.activityName || "");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [startTime, setStartTime] = useState(moment().format("HH:mm"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [endTime, setEndTime] = useState(moment().format("HH:mm"));
  const [guestvalus, setGuestvalus] = useState("");
  const [location, setLocation] = useState("");
  const [selectedMeeting, setSelectedMeeting] = useState("zoom_meeting");
  const [description, setDescription] = useState("");
  const [availableType, setAvailableType] = useState("Busy");
  const [notes, setNotes] = useState("");
  const [markAsDone, seTmarkAsDone] = useState(false);
  const [CalendarEvents, setCalendarEvents] = useState([]);
  const [Error, setError] = useState('');
  const [Priority, setPriority] = useState("");
  const [selectedOrganization, setselectedOrganization] = useState({ label: leadData?.organizationName, value: leadData?.organizationID });
  const [selectedPerson, setselectedPerson] = useState({ label: leadData?.name ? leadData.name : leadData?.personName, value: leadData?.peopleID, } || null);
  const [selectedDeal, setSelectedDeal] = useState(leadData?.dealID ? { label: leadData?.title, value: leadData?.dealID, } : null);
  const [selectedLead, setSelectedLead] = useState(leadData?.leadID ? { label: leadData?.title, value: leadData?.leadID, } : null);
  const [selectedProject, setSelectedProject] = useState(null);

  const [showAdvanced, setShowAdvanced] = useState(false);

  useEffect(() => {
    dispatch(getAllDeals({}));
    dispatch(getLeadmaster({ search: '', limit: 0, pageNumber: 0, objSearch: {} }));
    dispatch(getProject({}));
  }, [dispatch]);

  useEffect(() => {
    setCalendarEvents({
      title: labelActivityPlaceholder,
      start: `${startDate}T${startTime}`,
      end: `${endDate}T${endTime}`,
    });
  }, [startDate, endDate, startTime, endTime, labelActivityPlaceholder]);

  useEffect(() => {
    if (editActivityData && editActivityData?.activityID) {
      setActivityName(editActivityData?.activityName);
      setStartDate(moment(editActivityData?.startDate).format("YYYY-MM-DD"));
      setStartTime(editActivityData?.startTime);
      setEndDate(moment(editActivityData?.endDate).format("YYYY-MM-DD"));
      setEndTime(editActivityData?.endTime);
      setGuestvalus(editActivityData?.guests || "");
      setLocation(editActivityData?.locations || "");
      setSelectedMeeting(editActivityData?.meetingType || "zoom_meeting");
      setDescription(editActivityData?.description || "");
      setAvailableType(editActivityData?.availableType || "Busy");
      setNotes(editActivityData?.notes || "");
      setLabelActivityPlaceholder(editActivityData?.activityType ? editActivityData?.activityType : labelActivityPlaceholder);
      setPriority(editActivityData?.priority ? editActivityData?.priority : Priority);
      if (editActivityData?.organizationID) { setselectedOrganization({ label: editActivityData?.organizationName, value: editActivityData?.organizationID, }); }
      if (editActivityData?.peopleID) { setselectedPerson({ label: editActivityData?.peopleName, value: editActivityData?.peopleID, }); }
      if (editActivityData?.dealID) { setSelectedDeal({ label: editActivityData?.dealName, value: editActivityData?.dealID, }); }
      if (editActivityData?.leadID) { setSelectedLead({ label: editActivityData?.leadName, value: editActivityData?.leadID, }); }
      if (editActivityData?.projectID) { setSelectedProject({ label: editActivityData?.projectName, value: editActivityData?.projectID, }); }
      if (editActivityData?.markAsDone) seTmarkAsDone(editActivityData?.markAsDone ? editActivityData?.markAsDone : markAsDone);
    }
  }, [editActivityData, editActivityData?.startDate, editActivityData?.endDate]);

  const handleIconClick = (placeholder) => { setLabelActivityPlaceholder(placeholder); };

  const handleContentGuestChange = (newContent) => { setNotes(newContent); };

  const handleMarkAsDone = (e) => { seTmarkAsDone(e.target.checked); };

  const handleSaveActivity = async () => {
    const finalActivityName = activityName || `${labelActivityPlaceholder} activity`;

    const payload = {
      activityID: editActivityData?.activityID ? editActivityData?.activityID : 0,
      activityName: finalActivityName,
      activityType: labelActivityPlaceholder,
      startDate: startDate,
      startTime: startTime,
      endDate: endDate,
      endTime: endTime,
      guests: guestvalus,
      locations: location,
      meetingType: selectedMeeting,
      description: description,
      availableType: availableType,
      notes: notes,
      userID: 0,
      peopleID: selectedPerson && selectedPerson.value,
      organizationID: selectedOrganization && selectedOrganization.value,
      markAsDone: markAsDone,
      identityID: identityID,
      identityName: identityName,
      type: "Activity",
      priority: Priority,
      leadID: selectedLead?.value,
      projectID: selectedProject?.value,
      dealID: selectedDeal?.value,
    };
    await dispatch(saveActivity(payload)).then((res) => {
      cancel();
      if (res.payload.statusCode === 200) {
        setLoadFist(true);
        setError('');
        setCalendarEvents([]);
      }
    }).catch((error) => {
      console.log('error :>> ', error);
    });
  };

  const clearFrom = () => {
    setLabelActivityPlaceholder("Call");
    setActivityName("");
    setGuestvalus("");
    setLocation("");
    setSelectedMeeting("zoom_meeting");
    setDescription("");
    setAvailableType("Busy");
    setNotes("");
    seTmarkAsDone(false);
    setselectedOrganization('');
    setselectedPerson('');
  };

  const cancel = async () => {
    await clearFrom();
    await handleCancel();
  };

  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);
    const MatchDates = newStartDate === endDate;
    setEndDate(MatchDates ? endDate : newStartDate > endDate ? newStartDate : endDate);
  };

  const handleStartTimeChange = (e) => {
    const newStartTime = e.target.value;
    setStartTime(newStartTime);
    const MatchDates = newStartTime === endTime;
    setEndTime(MatchDates ? endTime : newStartTime > endTime ? newStartTime : endTime);
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);
  };

  const handleEndTimeChange = (e) => {
    const newEndTime = e.target.value;
    setEndTime(newEndTime);
    setStartTime(newEndTime < startTime ? newEndTime : startTime);
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-6 min-h-[440px] pr-1">
        <div className="col-span-12 lg:col-span-7 flex flex-col gap-4">
          <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 shadow-sm rounded-xl p-4 flex flex-col gap-3">
            <input
              type="text"
              name="activityName"
              placeholder={`Activity Name (e.g. ${labelActivityPlaceholder})`}
              className="border border-slate-200 dark:border-slate-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all duration-200 shadow-sm p-3 w-full rounded-xl bg-white dark:bg-slate-900 text-slate-800 dark:text-white text-sm font-semibold"
              onChange={(e) => setActivityName(e.target.value)}
              value={activityName}
            />
            {activityName && activityName.length > 0 ? "" : Error && (
              <div className="error text-red-650 text-xs font-bold px-1">{Error}</div>
            )}

            <div className="flex flex-wrap gap-1.5 mt-1 p-1 bg-slate-50 dark:bg-slate-950/60 rounded-xl border border-slate-100 dark:border-slate-850 w-max">
              <button
                type="button"
                onClick={() => handleIconClick("Call")}
                className={`w-10 h-10 rounded-xl flex items-center justify-center border transition-all ${labelActivityPlaceholder === "Call"
                  ? "bg-blue-50/50 border-blue-550 text-blue-600 dark:bg-slate-800 dark:border-blue-550 dark:text-blue-400 shadow-sm"
                  : "bg-white border-slate-200 text-slate-400 hover:text-slate-600 dark:bg-slate-900 dark:border-slate-800 dark:hover:text-slate-300"
                  }`}
              >
                <IoCall className="w-4 h-4" />
              </button>
              <button
                type="button"
                onClick={() => handleIconClick("Meeting")}
                className={`w-10 h-10 rounded-xl flex items-center justify-center border transition-all ${labelActivityPlaceholder === "Meeting"
                  ? "bg-blue-50/50 border-blue-550 text-blue-600 dark:bg-slate-800 dark:border-blue-550 dark:text-blue-400 shadow-sm"
                  : "bg-white border-slate-200 text-slate-400 hover:text-slate-600 dark:bg-slate-900 dark:border-slate-800 dark:hover:text-slate-300"
                  }`}
              >
                <FaUserGroup className="w-4 h-4" />
              </button>
              <button
                type="button"
                onClick={() => handleIconClick("Task")}
                className={`w-10 h-10 rounded-xl flex items-center justify-center border transition-all ${labelActivityPlaceholder === "Task"
                  ? "bg-blue-50/50 border-blue-550 text-blue-600 dark:bg-slate-800 dark:border-blue-550 dark:text-blue-400 shadow-sm"
                  : "bg-white border-slate-200 text-slate-400 hover:text-slate-600 dark:bg-slate-900 dark:border-slate-800 dark:hover:text-slate-300"
                  }`}
              >
                <MdOutlineWatchLater className="w-4 h-4" />
              </button>
              <button
                type="button"
                onClick={() => handleIconClick("Deadline")}
                className={`w-10 h-10 rounded-xl flex items-center justify-center border transition-all ${labelActivityPlaceholder === "Deadline"
                  ? "bg-blue-50/50 border-blue-550 text-blue-600 dark:bg-slate-800 dark:border-blue-550 dark:text-blue-400 shadow-sm"
                  : "bg-white border-slate-200 text-slate-400 hover:text-slate-600 dark:bg-slate-900 dark:border-slate-800 dark:hover:text-slate-300"
                  }`}
              >
                <AiFillFlag className="w-4 h-4" />
              </button>
              <button
                type="button"
                onClick={() => handleIconClick("Email")}
                className={`w-10 h-10 rounded-xl flex items-center justify-center border transition-all ${labelActivityPlaceholder === "Email"
                  ? "bg-blue-50/50 border-blue-550 text-blue-600 dark:bg-slate-800 dark:border-blue-550 dark:text-blue-400 shadow-sm"
                  : "bg-white border-slate-200 text-slate-400 hover:text-slate-600 dark:bg-slate-900 dark:border-slate-800 dark:hover:text-slate-300"
                  }`}
              >
                <MdEmail className="w-4 h-4" />
              </button>
              <button
                type="button"
                onClick={() => handleIconClick("Lunch")}
                className={`w-10 h-10 rounded-xl flex items-center justify-center border transition-all ${labelActivityPlaceholder === "Lunch"
                  ? "bg-blue-50/50 border-blue-555 text-blue-600 dark:bg-slate-800 dark:border-blue-555 dark:text-blue-400 shadow-sm"
                  : "bg-white border-slate-200 text-slate-400 hover:text-slate-600 dark:bg-slate-900 dark:border-slate-800 dark:hover:text-slate-300"
                  }`}
              >
                <IoRestaurant className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* Date Pickers Rows */}
          <div className="flex flex-col gap-3">
            <div className="flex gap-4">
              <div className="relative flex-1">
                {/* <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
                  <FiCalendar className="w-3.5 h-3.5" />
                </span> */}
                <input
                  name="start_date"
                  type="date"
                  className="w-full pl-5 pr-3 py-2.5 bg-white border border-slate-200 rounded-xl text-slate-700 text-xs dark:bg-slate-900 dark:border-slate-805 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all shadow-sm font-semibold"
                  onChange={handleStartDateChange}
                  value={startDate}
                />
              </div>
              <div className="relative flex-1">

                <input
                  type="time"
                  name="start_time"
                  value={startTime}
                  className="w-full pl-3 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-slate-700 text-xs dark:bg-slate-900 dark:border-slate-805 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all shadow-sm font-semibold"
                  onChange={handleStartTimeChange}
                />
              </div>
            </div>

            <div className="flex gap-4">
              <div className="relative flex-1">

                <input
                  name="end_date"
                  min={startDate}
                  onChange={handleEndDateChange}
                  value={endDate}
                  type="date"
                  className="w-full pl-5 pr-3 py-2.5 bg-white border border-slate-200 rounded-xl text-slate-700 text-xs dark:bg-slate-900 dark:border-slate-805 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all shadow-sm font-semibold"
                />
              </div>
              <div className="relative flex-1">
                <input
                  type="time"
                  name="end_time"
                  required
                  min={startTime || '00:00'}
                  value={endTime}
                  className="w-full pl-3 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-slate-700 text-xs dark:bg-slate-900 dark:border-slate-805 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all shadow-sm font-semibold"
                  onChange={handleEndTimeChange}
                />
              </div>
            </div>
          </div>

          {/* Guests & Location */}
          <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 rounded-2xl p-4 flex flex-col gap-3.5 shadow-sm">
            <div className="flex flex-col gap-1.5">
              <label htmlFor="Guests" className="text-[10px] text-slate-400 font-bold uppercase tracking-wider px-0.5">
                Guests
              </label>
              <input
                type="text"
                id="Guests"
                name="guests"
                placeholder="Add guests"
                className="border border-slate-200 dark:border-slate-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all duration-200 shadow-sm p-2.5 w-full rounded-xl bg-white dark:bg-slate-900 text-slate-800 dark:text-white text-xs font-bold"
                onChange={(e) => setGuestvalus(e.target.value)}
                value={guestvalus}
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <label htmlFor="location" className="text-[10px] text-slate-400 font-bold uppercase tracking-wider px-0.5">
                Location
              </label>
              <input
                type="text"
                name="location"
                placeholder="Add location"
                className="border border-slate-200 dark:border-slate-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all duration-200 shadow-sm p-2.5 w-full rounded-xl bg-white dark:bg-slate-900 text-slate-800 dark:text-white text-xs font-bold"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
            </div>
          </div>

          {/* Toggle advanced settings */}
          <button
            type="button"
            onClick={() => setShowAdvanced(!showAdvanced)}
            className="text-[10px] font-bold text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 self-start px-1.5 transition-colors"
          >
            {showAdvanced ? "— Hide Advanced Options" : "+ Show Advanced Options"}
          </button>

          {showAdvanced && (
            <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-805 rounded-2xl p-4 flex flex-col gap-3.5 shadow-sm">
              <div className="flex flex-col gap-1.5">
                <label className="text-[10px] text-slate-400 font-bold uppercase tracking-wider px-0.5">
                  Activity Title (Optional)
                </label>
                <input
                  type="text"
                  name="activityName"
                  placeholder={`Activity Title`}
                  className="border border-slate-200 dark:border-slate-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all duration-200 shadow-sm p-2.5 w-full rounded-xl bg-white dark:bg-slate-900 text-slate-800 dark:text-white text-xs font-bold"
                  onChange={(e) => setActivityName(e.target.value)}
                  value={activityName}
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-1.5">
                  <label className="text-[10px] text-slate-400 font-bold uppercase tracking-wider px-0.5">
                    Video Call Integration
                  </label>
                  <select
                    value={selectedMeeting}
                    onChange={(e) => setSelectedMeeting(e.target.value)}
                    className="bg-white border border-slate-200 text-slate-700 text-xs rounded-xl focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 block w-full p-2.5 dark:bg-slate-900 dark:border-slate-800 dark:text-white shadow-sm font-semibold"
                  >
                    <option value="zoom_meeting">Zoom Meeting</option>
                    <option value="microsoft_teams_meeting">Microsoft Teams Meeting</option>
                    <option value="google_meet_meeting">Google Meet Meeting</option>
                  </select>
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-[10px] text-slate-400 font-bold uppercase tracking-wider px-0.5">
                    Priority
                  </label>
                  <select
                    value={Priority}
                    onChange={(e) => setPriority(e.target.value)}
                    className="bg-white border border-slate-200 text-slate-700 text-xs rounded-xl focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 block w-full p-2.5 dark:bg-slate-900 dark:border-slate-800 dark:text-white shadow-sm font-semibold"
                  >
                    <option className="hidden">Priority</option>
                    <option value="None">None</option>
                    <option value="HIGH">HIGH</option>
                    <option value="MEDIUM">MEDIUM</option>
                    <option value="LOW">LOW</option>
                  </select>
                </div>
              </div>

              <div className="flex flex-col gap-1.5">
                <label className="text-[10px] text-slate-400 font-bold uppercase tracking-wider px-0.5">
                  Description
                </label>
                <textarea
                  name="description"
                  placeholder="Activity description details..."
                  className="border border-slate-200 dark:border-slate-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all duration-200 shadow-sm p-2.5 w-full rounded-xl bg-white dark:bg-slate-900 text-slate-800 dark:text-white text-xs font-semibold h-16 resize-y"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-1.5">
                  <label className="text-[10px] text-slate-400 font-bold uppercase tracking-wider px-0.5">
                    Calendar Status
                  </label>
                  <select
                    value={availableType}
                    onChange={(e) => setAvailableType(e.target.value)}
                    className="bg-white border border-slate-200 text-slate-700 text-xs rounded-xl focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 block w-full p-2.5 dark:bg-slate-900 dark:border-slate-800 dark:text-white shadow-sm font-semibold"
                  >
                    <option value="Busy">Busy</option>
                    <option value="Free">Free</option>
                  </select>
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-[10px] text-slate-400 font-bold uppercase tracking-wider px-0.5">
                    Owner
                  </label>
                  <input
                    type="text"
                    name="owner"
                    defaultValue="Dhruv Admin"
                    className="border border-slate-200 dark:border-slate-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all duration-200 shadow-sm p-2.5 w-full rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-500 dark:text-slate-450 text-xs font-semibold cursor-not-allowed"
                    disabled
                  />
                </div>
              </div>

              <div className="flex flex-col gap-1.5">
                <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider px-0.5">CRM Notes</span>
                <ReactQuill
                  theme="snow"
                  value={notes}
                  onChange={handleContentGuestChange}
                  className="bg-white dark:bg-slate-900 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-800"
                />
                <small className="text-[10px] text-slate-400 font-medium px-0.5">
                  * Notes are visible internally within Display CRM, but not sent to guests.
                </small>
              </div>

              <div className="border border-slate-100 dark:border-slate-850 p-4 rounded-xl bg-slate-50/40 dark:bg-slate-950/20 flex flex-col gap-3.5">
                <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">CRM Object Linking</span>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] text-slate-405 font-semibold px-0.5">Link Title</label>
                    <input
                      type="text"
                      name="title"
                      defaultValue={leadData?.title}
                      className="border border-slate-200 dark:border-slate-800 p-2 w-full rounded-lg bg-slate-50 dark:bg-slate-950 text-slate-500 text-xs font-semibold cursor-not-allowed"
                      disabled
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] text-slate-405 font-semibold px-0.5">Linked Lead</label>
                    <ReactSelect
                      selectedValue={selectedLead}
                      options={
                        Leadstore && Leadstore?.leadsData?.length > 0
                          ? Leadstore.leadsData.map((item) => ({
                            value: item?.leadID,
                            label: item?.title,
                            isDisabled: identityName === 'lead'
                          }))
                          : [{ value: "", label: "Not Found" }]
                      }
                      handleSelectChange={(option) => { setSelectedLead(option) }}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-3">
                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] text-slate-405 font-semibold px-0.5">Linked Project</label>
                    <ReactSelect
                      selectedValue={selectedProject}
                      options={
                        Projectstore && Projectstore?.getProject?.length > 0
                          ? Projectstore.getProject.map((item) => ({
                            value: item?.projectID,
                            label: item?.title,
                          }))
                          : [{ value: "", label: "Not Found" }]
                      }
                      handleSelectChange={(option) => { setSelectedProject(option) }}
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] text-slate-405 font-semibold px-0.5">Linked Deal</label>
                    <ReactSelect
                      selectedValue={selectedDeal}
                      options={
                        Dealstore && Dealstore?.getDeals?.length > 0
                          ? Dealstore?.getDeals?.map((item) => ({
                            value: item?.dealID,
                            label: item?.title,
                            isDisabled: identityName === 'Deal'
                          }))
                          : [{ value: "", label: "Not Found" }]
                      }
                      handleSelectChange={(option) => setSelectedDeal(option)}
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] text-slate-405 font-semibold px-0.5">Contact Person</label>
                    <ReactSelect
                      selectedValue={selectedPerson}
                      options={
                        Peoplestore &&
                          Peoplestore?.getAllPerson?.length > 0
                          ? Peoplestore?.getAllPerson?.map((item) => ({
                            value: item?.personMasterID ?? "",
                            label: item?.name,
                            isDisabled: identityName === 'people'
                          }))
                          : [{ value: "", label: "Not Found" }]
                      }
                      handleSelectChange={(option) => setselectedPerson(option)}
                    />
                  </div>
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-[10px] text-slate-405 font-semibold px-0.5">Linked Organization</label>
                  <ReactSelect
                    selectedValue={selectedOrganization}
                    options={
                      organizationstore &&
                        organizationstore?.organizationData?.data?.length >
                        0
                        ? organizationstore?.organizationData?.data.map(
                          (item) => ({
                            value: item?.organizationID ?? "",
                            label: item?.organizationName,
                          })
                        )
                        : [{ value: "", label: "Not Found" }]
                    }
                    handleSelectChange={(option) => setselectedOrganization(option)}
                  />
                </div>
              </div>

              <div className="flex items-center gap-2 px-1">
                <input
                  type="checkbox"
                  id="markAsDone"
                  className="w-4 h-4 text-indigo-600 bg-slate-100 border-slate-350 rounded focus:ring-indigo-500 focus:ring-2"
                  onChange={handleMarkAsDone}
                  checked={markAsDone}
                />
                <label htmlFor="markAsDone" className="text-xs font-bold text-slate-700 dark:text-slate-350 cursor-pointer select-none">
                  Mark activity as done
                </label>
              </div>
            </div>
          )}

          {/* Action Row */}
          <div className="flex justify-end gap-2.5 mt-2">
            <button
              className="px-4 py-2 text-xs font-bold text-slate-500 hover:bg-slate-100 rounded-xl transition-all dark:text-slate-400 dark:hover:bg-slate-800"
              onClick={() => cancel()}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-5 py-2.5 text-xs font-bold text-white bg-blue-600 hover:bg-blue-700 rounded-xl shadow-md shadow-blue-100 dark:shadow-none hover:shadow-lg transition-all"
              onClick={() => handleSaveActivity()}
            >
              {editActivityData && editActivityData?.activityID ? 'Update' : 'Save'}
            </button>
          </div>
        </div>

        {/* Right Calendar Column */}
        <div className="col-span-12 lg:col-span-5">
          <div className="activity w-full bg-white dark:bg-slate-900 p-4 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm">
            <FullCalendar
              className="overflow-auto rounded-xl"
              eventColor="#3b82f6"
              selectMirror
              weekends={false}
              headerToolbar={{
                left: "prev,next",
                center: "title",
                right: "today",
              }}
              plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
              initialView="timeGridDay"
              slotLabelFormat={{
                hour: "numeric",
                minute: "2-digit",
                omitZeroMinute: false,
                hour12: true,
              }}
              events={[
                CalendarEvents
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Activity;
